module.exports = __webpack_public_path__ + "static/media/waterfront.68e1a43b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/waterfront.jpg
// module id = 1130
// module chunks = 0